import { useQuery } from '@tanstack/react-query';
import {
  InvestigationsCaseResponse,
  InvestigationsPayload,
} from 'app/modules/investigations/types';
import { CachedInvestigationsCaseResponse } from 'app/modules/investigations/types/responses';
import { useSelector } from 'react-redux';
import { selectHasReadCasesPermissions } from 'app/modules/session/selectors';
import { CASE_QUERY_KEYS } from 'app/modules/cases/queries/keys';
import { selectDLEnabledForCaseList } from 'app/shared/featureFlags/selectors';
import { post } from 'app/shared/utils/fetchr';

const retrieveInvestigationsCases = <TResponse>(
  payload: InvestigationsPayload,
) => {
  // DEPRECATED we are transitioning to the new cached endpoint
  return post<TResponse>('/investigations/retrieve/case-list', payload);
};

export const useListCases = (payload: InvestigationsPayload) => {
  const hasReadCasesPermission = useSelector(selectHasReadCasesPermissions);
  const useNewEndpoint = useSelector(selectDLEnabledForCaseList);

  return useQuery({
    queryKey: CASE_QUERY_KEYS.listCases({
      payload,
      useCacheEndpoint: useNewEndpoint,
    }),
    queryFn: () =>
      useNewEndpoint
        ? post<CachedInvestigationsCaseResponse>(
            '/cases/cached/list',
            payload.object_filters,
          )
        : retrieveInvestigationsCases<InvestigationsCaseResponse>(payload),
    enabled: hasReadCasesPermission,
  });
};
